export default {
  emptyNotice: 'コンテンツがありません',
}
